export default __webpack_public_path__ + "media/images/Arrow_Button-28518c9bfdc9872edc81697cc61204dd.png";